export default class ErrorMiddleware {

  responseHasError(res) {

    return res && res.status !== 200

  }

  parseResponseForError(res) {

    let err = {
      httpStatus: res.status,
      httpStatusText: res.statusText,
    }

    if (
      res.text === undefined
      || res.type !== 'application/json'
    ) {
      return err
    }

    try {
      err = {
        ...err,
        ...JSON.parse(res.text)
      }
    }
    catch (ex) {
      console.error('Error parsing json response:', res.text)
    }

    return err

  }

  response({ res, err }) {

    if (this.responseHasError(res)) {

      err = this.parseResponseForError(res)

      err = err.error

    }

    if (err) {

      res = null
      return { err, res }

    }

    return null

  }

}



// WEBPACK FOOTER //
// ./src/shared/api/middleware/error.js